import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const brandMonitoringFutureConfig: RouterStateConfig = {
    "brandmonitoring.**": {
        url: "/digitalsuite/brand-protection",
        lazyLoad: () => import("single-spa/react-app/config/solutions25/campaigns/brandMonitoringConfig"),
    },
};
